import { useInferenceCreateContext } from "domains/inference/contexts/InferenceProvider";
import SliderWithInputNumber from "domains/ui/components/SliderWithInputNumber";

interface SidebarSliderInfluenceProps {
  type: "reference" | "control" | "ipAdapter";
  title?: string;
}

export default function SidebarSliderInfluence({
  type,
  title = "Influence",
}: SidebarSliderInfluenceProps) {
  const { referenceInfluences, setReferenceInfluence } =
    useInferenceCreateContext();

  return (
    <SliderWithInputNumber
      valueStyleProps={{ w: "50px" }}
      title={title}
      tooltip="Higher values amplify the weight of the reference image."
      value={parseInt((referenceInfluences[type] * 100).toFixed(0))}
      setValue={(newValue) => {
        setReferenceInfluence(
          type,
          newValue !== undefined
            ? parseFloat((newValue / 100).toFixed(2))
            : referenceInfluences[type]
        );
      }}
      min={1}
      max={100}
      data-testid="inference-builder-influence-slider"
      step={1}
    />
  );
}
